import { IconWrapper } from '../runtime';
export default IconWrapper('board', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.5 1.74976H14.5M2.75 2.49976V9.99976C2.75 10.8282 3.42157 11.4998 4.25 11.4998H11.75C12.5784 11.4998 13.25 10.8282 13.25 9.99976V2.49976M4.5 14.4998L7.5 11.4998M8.5 11.4998L11.5 14.4998M5 7.49976L6.76574 5.29258C6.88584 5.14246 7.11416 5.14246 7.23426 5.29258L8.76574 7.20693C8.88584 7.35705 9.11416 7.35705 9.23426 7.20693L11 4.99976",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});